import React                            from 'react';
import { Observe }                      from 'rewire-core';
import { WithStyle }                    from 'rewire-ui';
import { Theme }                        from '@material-ui/core/styles';
import Typography                       from '@material-ui/core/Typography';
import Button                           from '@material-ui/core/Button';
import InfoPanelShiftNavigation         from './InfoPanelShiftNavigation';
import { IEmployee }                    from '../DataTypes';
import infoPanelShiftEmployeesViewModel from './InfoPanelShiftEmployeesViewModel';
import scheduleModel                    from './ScheduleModel';
import { withStyles }                   from '../utility/styles';
import employeeDialogModel              from './EmployeeDialogModel';
import EmployeeDialog                   from './EmployeeDialog';

const styles = (theme: Theme) => ({
  contentInnerContainer: {
    marginBottom: '15px',
  },
  shiftNavigation: {
    marginBottom: '10px',
  },
  employeeButton: {
    minWidth: '0px',
    minHeight: '0px',
    textTransform: 'none',
    padding: '0px 5px',
    '&:hover': {
      color: theme.palette.dialogPrimary.main,
    },
  },
  employeeInfo: {
    marginLeft: '5px',
  },
});

interface IInfoPanelShiftEmployeesViewProps {
  classes?: any;
}

type InfoPanelShiftEmployeesViewProps = WithStyle<ReturnType<typeof styles>, IInfoPanelShiftEmployeesViewProps>;

class InfoPanelShiftEmployeesView extends React.PureComponent<InfoPanelShiftEmployeesViewProps> {
  constructor(props: InfoPanelShiftEmployeesViewProps) {
    super(props);
  }

  getOnEmployeeClick = (employeeId: string) => () => {
    employeeDialogModel.load(employeeId);
  };

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      < >
        {scheduleModel.viewMode === 'Job' && <InfoPanelShiftNavigation className={classes.shiftNavigation} title='Shift' />}
        {!infoPanelShiftEmployeesViewModel.employees.length
          ? <div className={classes.contentInnerContainer}>
              <Typography><strong>No Employee</strong></Typography>
            </div>
          : infoPanelShiftEmployeesViewModel.employees.map((employee: IEmployee) => (
              <div key={employee.id} className={classes.contentInnerContainer}>
                <Button className={classes.employeeButton} onClick={this.getOnEmployeeClick(employee.id)}><Typography><strong>{employee.name}</strong></Typography></Button>
                <Typography className={classes.employeeInfo} variant='body2'>{employee.email}</Typography>
                <Typography className={classes.employeeInfo} variant='body2'>{employee.phone && employee.phone.home}</Typography>
              </div>
            ))}
        <EmployeeDialog />
      </>
    )} />;
  }
}

export default withStyles<IInfoPanelShiftEmployeesViewProps>(styles, InfoPanelShiftEmployeesView);
